import { SketchNoteLogoIcon } from '@sketchnote/icons';
import Link from 'next/link';

export const FormFooter = ({ isPreview }: { isPreview: boolean }) => {
  return !isPreview ? (
    <Link href="/signin">
      <a>
        <div className="bottom-10 mr-24 right-2 flex justify-center w-221 py-12 px-8 rounded-sm border border-gray-200 shadow-sm  bg-white">
          <div className="text-gray-600">Made with</div>
          <div className="flex items-center ml-2">
            <SketchNoteLogoIcon className="text-primary-500 text-xl" />
            <span className="text-primary-800 font-extraBold text-base">sketchnote</span>
          </div>
        </div>
      </a>
    </Link>
  ) : (
    <div className="bottom-10 mr-24 right-2 flex justify-center w-221 py-12 px-8 rounded-sm border border-gray-200 shadow-sm  bg-white">
      <div className="text-gray-600">Made with</div>
      <div className="flex items-center ml-2">
        <SketchNoteLogoIcon className="text-primary-500 text-xl" />
        <span className="text-primary-800 font-extraBold text-base">sketchnote</span>
      </div>
    </div>
  );
};
